module.exports = __webpack_public_path__ + "static/media/personalInvestmentAccount.65be4cf4.svg";